import { serviceBulletinsModel } from './service-bulletins-model'
import { z } from 'my-zod'

export const updateServiceBulletinSystemRequest = serviceBulletinsModel.pick({
  id: true,
  polarisId: true,
  subject: true,
  type: true,
  pdfUrl: true
})

export type updateServiceBulletinSystemRequest = z.infer<typeof updateServiceBulletinSystemRequest>
